
import './App.css';
import { TodoWrapper } from './components/TodoWrapper';
import { Pomonic } from './components/Pomonic'

function App() {
  return (
    <div className="App">
      <TodoWrapper/>
      <Pomonic/>
    </div>
  );
}

export default App;
